import { useChatGlobalStateStore } from "@/store/ChatGlobalState"
import { useGlobalStateStore } from "@/store/GlobalState"
import useSocket from "@/hooks/useSocket"
import { ChannelType } from "@/protocols/channel"
import { errorCodeToMessage } from "@/utils/startChat"
import ErrorHandlerService from "@/services/ErrorHandler"
import { ErrorType } from "@/hooks/useValidation"

const useStartChat = () => {
	const socket = useSocket()
	const chatGlobalStateStore = useChatGlobalStateStore()
	const globalStateStore = useGlobalStateStore()

	const startChat = async (clientId: number, contactId: number): Promise<string | null> => {
		try {
			if (!globalStateStore.isCurrentChannelConnected) {
				return errorCodeToMessage.InboxChannelIsInactive
			}

			const currentChannel = globalStateStore.currentChannel

			const chat = await socket.startChat({
				channelType: currentChannel?.channelType as ChannelType,
				clientId,
				contactId,
				inboxChannelId: currentChannel?.id as number
			})

			if (!chat) {
				return errorCodeToMessage.NoValidContactFound
			}

			const isThereAnyAttendanceInProgress = Boolean(chat?.attendance?.userId)
			const isThereAnyAttendanceInProgressWithMe = chat?.attendance?.userId === globalStateStore?.user?.id

			if (isThereAnyAttendanceInProgress && !isThereAnyAttendanceInProgressWithMe) {
				return errorCodeToMessage.ClientHasChatInProgressWithAnotherAttendant
			}

			const chatAlreadyExists = chatGlobalStateStore.chat.existsById(chat.id)

			if (!chatAlreadyExists) {
				chatGlobalStateStore.chat.add(chat)
			}

			chatGlobalStateStore.chat.openById(chat.id)

			chatGlobalStateStore.attendance.takeByChatId(chat.id)

			return null
		} catch (err) {
			ErrorHandlerService.handle(err as ErrorType)

			return errorCodeToMessage.Default
		}
	}

	return { startChat }
}

export default useStartChat
